import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { DndModule } from 'ngx-drag-drop';

import {SharedModule} from '../shared/shared.module';

import {AffiliatesComponent} from './affiliates.component';
import {IntroOutroComponent} from './intro-outro.component';
import {MsnFieldsComponent} from './msn-fields.component';
import {NotesComponent} from './notes.component';
import {PageAddWriterComponent, MemberHasRole} from './page-add-writer.component';
import {PriorityComponent} from './priority.component';
import {QuizTypeComponent} from './quiz-type.component';
import {PropertiesComponent, SiteSearchPipe, HasSitePipe, SiteSettingsDialog, SlugDialog, ImagesDialog, TaxOptionsDialog, TermSearchPipe} from './properties.component';
import {SitesComponent} from './sites.component';
import {RichtextComponent} from './richtext.component';
import {RoleComponent} from './role.component';
import {SiteCategoryComponent, CategoryDialog} from './site-category.component';
import {SlideCountComponent} from  './slideCount.component';
import {SlideWordCountComponent} from './slideWordCount.component';
import {SlugComponent} from './slug.component';
import {TagsComponent} from './tags.component';
import {TaxonomiesComponent} from './taxonomies.component';
import {TeamComponent, MemberSearchTeam, NotInTeam} from './team.component';

@NgModule({
    declarations: [
        CategoryDialog,
        AffiliatesComponent,
        IntroOutroComponent,
        NotesComponent,
        MemberSearchTeam,
        NotInTeam,
        PageAddWriterComponent,
        MemberHasRole,
        MsnFieldsComponent,
        PriorityComponent,
        QuizTypeComponent,
        PropertiesComponent,
        HasSitePipe,
        SiteSearchPipe,
        TermSearchPipe,
        SlugDialog,
        ImagesDialog,
        TaxOptionsDialog,
        SiteSettingsDialog,
        SitesComponent,
        RichtextComponent,
        RoleComponent,
        SiteCategoryComponent,
        SlideCountComponent,
        SlideWordCountComponent,
        SlugComponent,
        TagsComponent,
        TaxonomiesComponent,
        TeamComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        DndModule
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        CategoryDialog,
        AffiliatesComponent,
        IntroOutroComponent,
        NotesComponent,
        MemberSearchTeam,
        MsnFieldsComponent,
        NotInTeam,
        PageAddWriterComponent,
        MemberHasRole,
        PriorityComponent,
        QuizTypeComponent,
        PropertiesComponent,
        HasSitePipe,
        TermSearchPipe,
        SiteSearchPipe,
        SlugDialog,
        ImagesDialog,
        TaxOptionsDialog,
        SiteSettingsDialog,
        SitesComponent,
        RichtextComponent,
        RoleComponent,
        SiteCategoryComponent,
        SlideCountComponent,
        SlideWordCountComponent,
        SlugComponent,
        TagsComponent,
        TaxonomiesComponent,
        TeamComponent
    ]
})
export class FieldsModule { }